import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Attendance from "../views/attendance/Attendance.vue";
import Preferential from "../views/preferential/Preferential.vue";
import Login from "../views/login/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Attendance",
    component: Attendance,
    meta: { requiresAuth: true },
  },
  {
    path: "/preferential",
    name: "Preferential",
    component: Preferential,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.getToken;

  if (to.path === "/login" && isAuthenticated) {
    return next("/");
  }

  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isAuthenticated
  ) {
    return next("/login");
  }
  return next();
});

export default router;
